/**
 * Printer lane roles a work item's prints can be addressed to.
 *
 * A lane is the `(siteId, role)` pair the print envelope is addressed to; the
 * on-site agent resolves `role` → printer (see `cr001_printers`, seeded by
 * sm4rt-api's `scripts/setup/seed_printers.py`). Only the `role` half travels
 * from here: the site is sm4rt-api's configured default, and sending a role
 * against the wrong site would address a printer in another shop.
 *
 * Only the two label lanes are named here, because they are the only lanes a
 * *person* picks: the same job label goes upstairs to the bench or downstairs
 * to the counter depending on who is about to pick the machine up. Every other
 * document has exactly one lane that can render it (an A4 tax invoice cannot
 * come out of a 90mm Brother), so sm4rt-api resolves those from the document —
 * see `DOCUMENT_DEFAULT_ROLES` in `core/services/print_service.py`. Don't move
 * that decision here; a client that guesses wrong doesn't print small, it
 * raises a DispatchError on the agent and dead-letters with nothing on screen.
 */

/** Upstairs Brother, on the workshop bench. */
export const LABEL_LANE_WORKSHOP = 'label-workshop';

/** Downstairs Brother, at the reception counter. This is sm4rt-api's default. */
export const LABEL_LANE_COUNTER = 'label-counter';

/** Which floor a label lane is on — used for the ⬆ / ⬇ affordance. */
export type LabelFloor = 'upstairs' | 'downstairs';

export const LABEL_LANE_BY_FLOOR: Record<LabelFloor, string> = {
  upstairs: LABEL_LANE_WORKSHOP,
  downstairs: LABEL_LANE_COUNTER,
};
